// Skeleton for the optimal-slots panel during initial fetch.

import { cn } from "@shared/lib";

import { OPTIMAL_SLOTS_STRINGS } from "../lib/strings";

export interface OptimalSlotsPanelSkeletonProps {
  loadingLabel?: string;
  className?: string;
}

export function OptimalSlotsPanelSkeleton({
  loadingLabel = OPTIMAL_SLOTS_STRINGS.title,
  className,
}: OptimalSlotsPanelSkeletonProps) {
  return (
    <section
      aria-busy="true"
      aria-label={loadingLabel}
      className={cn("flex animate-pulse flex-col gap-2", className)}
    >
      <div className="h-4 w-32 rounded bg-muted" />
      <div className="h-3 w-56 rounded bg-muted" />
      <ol className="flex flex-col gap-2 pt-2">
        {Array.from({ length: 3 }, (_, idx) => (
          <li
            key={idx}
            className="flex items-center justify-between gap-3 rounded-lg border bg-background px-4 py-3"
          >
            <div className="flex min-w-0 items-center gap-3">
              <div className="h-7 w-7 flex-none rounded-full bg-muted" />
              <div className="flex min-w-0 flex-col gap-1">
                <div className="h-3 w-20 rounded bg-muted" />
                <div className="h-3 w-16 rounded bg-muted" />
              </div>
            </div>
            <div className="flex flex-none flex-col items-end gap-1">
              <div className="h-3 w-12 rounded bg-muted" />
              <div className="h-3 w-14 rounded bg-muted" />
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
